import { Component, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CategoryComponent } from "./category/category.component";
import { SupplierComponent } from "./supplier/supplier.component";

@Component({
    selector: "packbo-directory",
    templateUrl: "./directory.template.html",
    imports: [CategoryComponent, SupplierComponent]
})
export class DirectoryComponent {
    private readonly route = inject(ActivatedRoute);
    protected readonly pageType = this.route.snapshot.data["pageType"] || null;
}
